import { createSelector } from 'reselect'
import { resolveLoyaltyChooseDoubleRewardsMemberState } from '../utils/loyaltyChooseDoubleRewardsState'
import getLoyaltyChooseDoubleRewardsCampaignMetadata from './getLoyaltyChooseDoubleRewardsCampaignMetadata'

const getLoyaltyChooseDoubleRewardsMemberState = createSelector(
  (state: App.State) => state.loyalty.account.data?.earnDecisions,
  getLoyaltyChooseDoubleRewardsCampaignMetadata,
  resolveLoyaltyChooseDoubleRewardsMemberState,
)

export default getLoyaltyChooseDoubleRewardsMemberState
